/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ClientAssignedPermissionViewModel } from '../models/client-assigned-permission-view-model';
import { FeatureSwitchViewModel } from '../models/feature-switch-view-model';
import { Get } from '../fn/permissions/get';
import { Get$Params } from '../fn/permissions/get';
import { GetClientAssignedPermission } from '../fn/permissions/get-client-assigned-permission';
import { GetClientAssignedPermission$Params } from '../fn/permissions/get-client-assigned-permission';
import { GetFeatureSwitches } from '../fn/permissions/get-feature-switches';
import { GetFeatureSwitches$Params } from '../fn/permissions/get-feature-switches';
import { GetPermissionCategories } from '../fn/permissions/get-permission-categories';
import { GetPermissionCategories$Params } from '../fn/permissions/get-permission-categories';
import { GetPermissionTypes } from '../fn/permissions/get-permission-types';
import { GetPermissionTypes$Params } from '../fn/permissions/get-permission-types';
import { List } from '../fn/permissions/list';
import { List$Params } from '../fn/permissions/list';
import { PermissionCategoryViewModel } from '../models/permission-category-view-model';
import { PermissionModel } from '../models/permission-model';
import { PermissionTypeViewModel } from '../models/permission-type-view-model';
import { PermissionViewModelPrimeDatatableResults } from '../models/permission-view-model-prime-datatable-results';
import { Save } from '../fn/permissions/save';
import { Save$Params } from '../fn/permissions/save';
import { SaveClientAssignedPermission } from '../fn/permissions/save-client-assigned-permission';
import { SaveClientAssignedPermission$Params } from '../fn/permissions/save-client-assigned-permission';

@Injectable({ providedIn: 'root' })
export class PermissionsApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiPermissionsListPost()` */
  static readonly ApiPermissionsListPostPath = '/api/Permissions/List';

  /**
   * List Permission.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `List()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  List$Response(params?: List$Params, context?: HttpContext): Observable<StrictHttpResponse<PermissionViewModelPrimeDatatableResults>> {
    return List(this.http, this.rootUrl, params, context);
  }

  /**
   * List Permission.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `List$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  List(params?: List$Params, context?: HttpContext): Observable<PermissionViewModelPrimeDatatableResults> {
    return this.List$Response(params, context).pipe(
      map((r: StrictHttpResponse<PermissionViewModelPrimeDatatableResults>): PermissionViewModelPrimeDatatableResults => r.body)
    );
  }

  /** Path part for operation `apiPermissionsGetPost()` */
  static readonly ApiPermissionsGetPostPath = '/api/Permissions/Get';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `Get()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  Get$Response(params?: Get$Params, context?: HttpContext): Observable<StrictHttpResponse<PermissionModel>> {
    return Get(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `Get$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  Get(params?: Get$Params, context?: HttpContext): Observable<PermissionModel> {
    return this.Get$Response(params, context).pipe(
      map((r: StrictHttpResponse<PermissionModel>): PermissionModel => r.body)
    );
  }

  /** Path part for operation `apiPermissionsSavePost()` */
  static readonly ApiPermissionsSavePostPath = '/api/Permissions/Save';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `Save()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  Save$Response(params?: Save$Params, context?: HttpContext): Observable<StrictHttpResponse<PermissionModel>> {
    return Save(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `Save$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  Save(params?: Save$Params, context?: HttpContext): Observable<PermissionModel> {
    return this.Save$Response(params, context).pipe(
      map((r: StrictHttpResponse<PermissionModel>): PermissionModel => r.body)
    );
  }

  /** Path part for operation `apiPermissionsGetPermissionTypesGet()` */
  static readonly ApiPermissionsGetPermissionTypesGetPath = '/api/Permissions/GetPermissionTypes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetPermissionTypes()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPermissionTypes$Response(params?: GetPermissionTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PermissionTypeViewModel>>> {
    return GetPermissionTypes(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetPermissionTypes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPermissionTypes(params?: GetPermissionTypes$Params, context?: HttpContext): Observable<Array<PermissionTypeViewModel>> {
    return this.GetPermissionTypes$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PermissionTypeViewModel>>): Array<PermissionTypeViewModel> => r.body)
    );
  }

  /** Path part for operation `apiPermissionsGetPermissionCategoriesGet()` */
  static readonly ApiPermissionsGetPermissionCategoriesGetPath = '/api/Permissions/GetPermissionCategories';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetPermissionCategories()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPermissionCategories$Response(params?: GetPermissionCategories$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PermissionCategoryViewModel>>> {
    return GetPermissionCategories(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetPermissionCategories$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPermissionCategories(params?: GetPermissionCategories$Params, context?: HttpContext): Observable<Array<PermissionCategoryViewModel>> {
    return this.GetPermissionCategories$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PermissionCategoryViewModel>>): Array<PermissionCategoryViewModel> => r.body)
    );
  }

  /** Path part for operation `apiPermissionsGetFeatureSwitchesGet()` */
  static readonly ApiPermissionsGetFeatureSwitchesGetPath = '/api/Permissions/GetFeatureSwitches';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetFeatureSwitches()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetFeatureSwitches$Response(params?: GetFeatureSwitches$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FeatureSwitchViewModel>>> {
    return GetFeatureSwitches(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetFeatureSwitches$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetFeatureSwitches(params?: GetFeatureSwitches$Params, context?: HttpContext): Observable<Array<FeatureSwitchViewModel>> {
    return this.GetFeatureSwitches$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<FeatureSwitchViewModel>>): Array<FeatureSwitchViewModel> => r.body)
    );
  }

  /** Path part for operation `apiPermissionsGetClientAssignedPermissionPost()` */
  static readonly ApiPermissionsGetClientAssignedPermissionPostPath = '/api/Permissions/GetClientAssignedPermission';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetClientAssignedPermission()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  GetClientAssignedPermission$Response(params?: GetClientAssignedPermission$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientAssignedPermissionViewModel>> {
    return GetClientAssignedPermission(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetClientAssignedPermission$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  GetClientAssignedPermission(params?: GetClientAssignedPermission$Params, context?: HttpContext): Observable<ClientAssignedPermissionViewModel> {
    return this.GetClientAssignedPermission$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientAssignedPermissionViewModel>): ClientAssignedPermissionViewModel => r.body)
    );
  }

  /** Path part for operation `apiPermissionsSaveClientAssignedPermissionPost()` */
  static readonly ApiPermissionsSaveClientAssignedPermissionPostPath = '/api/Permissions/SaveClientAssignedPermission';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SaveClientAssignedPermission()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  SaveClientAssignedPermission$Response(params?: SaveClientAssignedPermission$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return SaveClientAssignedPermission(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SaveClientAssignedPermission$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  SaveClientAssignedPermission(params?: SaveClientAssignedPermission$Params, context?: HttpContext): Observable<void> {
    return this.SaveClientAssignedPermission$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
